import React from "react";
import styled from "styled-components";
import Img from "gatsby-image";

const KeyPerson = ({ img, name, description }) => {

  return (
    <div
      className="col-md-3 col-sm-3 text-center wow fadeIn features-2"
      data-wow-duration="300ms"
    >
      <div className="key-person">
        <div className="key-person-img">
          <img src={img.resolutions.src} />
        </div>
        <h5>{name}</h5>
        <div className="separator-line bg-yellow" />
        <p
          dangerouslySetInnerHTML={{
            __html: description
          }}
        />
      </div>
    </div>
  );
};

export default KeyPerson;



// WEBPACK FOOTER //
// ./src/components/KeyPerson/index.js